export default "__VITE_ASSET__870adb87__"